import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  width: fit-content;
  height: fit-content;

  animation: loading 3s linear infinite;

  @keyframes loading {
    0% {
      transform: rotateZ(0);
      opacity: 1;
    }
    33% {
      opacity: 0.3;
      filter: blur(1px);
    }
    100% {
      transform: rotateZ(360deg);
      opacity: 1;
      filter: blur(0);
    }
  }
`;
